// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"9cdf8fb5","236":"9cdf8fb5","580":"9cdf8fb5","642":"9cdf8fb5","693":"9cdf8fb5","964":"9cdf8fb5"}[chunkId] + ".chunk.css";
};